import { Editor } from '@tinymce/tinymce-react';
import React from 'react';
import { ObjFactory } from 'rt-sd-common/sgiFactory/ObjFactory';
import SgiComponent from './sgiBaseComp/SgiComponent';
import { sgiLogger } from 'rt-sd-common/sgiCommon/sgiLogger';
import { sgiFormCtlBaseFun } from './sgiFormCtlBaseFun';
import { AddFormCtlCommonAttribute, setFormCtlLayout, bindValue, bindEvent } from './sgiFormCtlComm';
import { Form } from 'antd';

export default class SgiTinyMCE extends SgiComponent {

    constructor(props) {
        super(props);

        //初始化state属性
        this.initState();
        this.state = {
            ...this.state,
            content: '',
            isFormItem: false
        };
        this.state.inputprops.init = {
            language: "zh_CN",
            branding: false, //This option allows you to disable the "Powered by TinyMCE" branding.
            menubar: "edit insert format table tools",
            height: "100%",
            body_class: "markdown-body",
            plugins: "image imagetools advlist code media link colorpicker paste table textcolor",
            toolbar: "undo redo | fontselect fontsizeselect | bold italic underline strikethrough | forecolor backcolor | bullist numlist | link image",
            selector: "textarea",
            paste_data_images: true
        };
    }

    /**
     * maker构建
     * @param {object} parentModule 
     * @param {object} moduleDesc       
     * @param {ObjFactory} objFct 
     * @param {string} type 
     */
    tinymce_mk(parentModule, moduleDesc, objFct, type) {
        //获取需要展示的数据信息
        if (!moduleDesc) {
            return;
        }

        //转换form公共属性
        AddFormCtlCommonAttribute(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
        //转换基础属性
        this.AddAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops);
        //设置布局
        setFormCtlLayout(moduleDesc, this.state.formItemProps, this.state.inputprops);
        //绑定值
        bindValue(this, moduleDesc, bdInst, objFct, this.state.formItemProps, this.state.inputprops);
        //绑定事件
        bindEvent(this, moduleDesc, this.state.formItemProps, this.state.inputprops, this.state.functions, type);
    }

    /**
     * 属性转换
     */
    AddAttribute(moduleDesc, formItemProps, inputprops) {

        if (!inputprops.init) inputprops.init = {};
        if (moduleDesc.language) inputprops.init.language = moduleDesc.language;
        if (moduleDesc.branding) inputprops.init.branding = moduleDesc.branding;//This option allows you to disable the "Powered by TinyMCE" branding.
        if (moduleDesc.menubar) inputprops.init.menubar = moduleDesc.menubar;
        if (moduleDesc.height) inputprops.init.height = moduleDesc.height;
        if (moduleDesc.body_class) inputprops.init.body_class = moduleDesc.body_class;
        if (moduleDesc.plugins) inputprops.init.plugins = moduleDesc.plugins;
        if (moduleDesc.toolbar) inputprops.init.toolbar = moduleDesc.toolbar;
        if (moduleDesc.selector) inputprops.init.selector = moduleDesc.selector;
        if (moduleDesc.paste_data_images || moduleDesc.paste_data_images === false) inputprops.init.paste_data_images = moduleDesc.paste_data_images;

        if (moduleDesc._formProps) this.state.isFormItem = true;

        // 自定义props
        let cstmPrps = moduleDesc.cstmPrps;
        if (cstmPrps) {
            let cstmPrpsObj;
            try {
                cstmPrpsObj = JSON.parse(cstmPrps);
            } catch (error) {
                sgiLogger.eventErr(error);
            }
            if (cstmPrpsObj) merge(inputprops, cstmPrpsObj);
        }
    }

    handleEditorChange = (content, editor) => {
        this.state.inputprops.onChange.call(this, content, editor);
        this.setState({ content });
    }

    //渲染并返回一个虚拟DOM
    render = function () {

        const { parentModule, moduleDesc, objFct, type } = this.props;

        if (!this.loaded) {
            //组装属性
            this.tinymce_mk(parentModule, moduleDesc, objFct, type);
            this.loaded = true;
        }

        // 合并相同属性，例如disabled属性，应由自身disabled属性及formDisabled属性同时控制
        const { _inputProps, _formItemProps } = this.getReviseProps();
        const { isLabel } = _inputProps;

        // 渲染前通用处理，如自定义样式等
        this.renderBeforeReturn();

        let editor = <Editor {...this.state.inputprops} {..._inputProps}
            // init={{
            //     language: "zh_CN",
            //     branding: false, //This option allows you to disable the "Powered by TinyMCE" branding.
            //     menubar: "edit insert format table tools",
            //     height: "100%",
            //     body_class: "markdown-body",
            //     plugins: "image imagetools advlist code media link colorpicker paste table textcolor",
            //     toolbar: "undo redo | fontselect fontsizeselect | bold italic underline strikethrough | forecolor backcolor | bullist numlist | link image",
            //     selector: "textarea",
            //     paste_data_images: true
            // }}
            value={this.state.content}
            onEditorChange={this.handleEditorChange} />;

        return this.state.isFormItem ? <Form.Item {...this.state.formItemProps} {..._formItemProps}>{editor}</Form.Item> : editor;
    }

}

//给类添加公共方法
Object.assign(SgiTinyMCE.prototype, sgiFormCtlBaseFun);

/**
 * 属性合并
 * @param {object} target 目标对象
 * @param {object} source 源对象
 */
function merge(target, source) {
    // 目标和源相同，直接返回
    if (target === source) return target;
    // 分情况处理
    if (Object.prototype.toString.call(target) === '[object Object]' && Object.prototype.toString.call(source) === '[object Object]') {
        for (let key in source) {
            if (target[key] === source[key]) continue;//相同，跳过
            if (!target[key]) target[key] = source[key];//target属性不存在，直接赋值
            else target[key] = merge(target[key], source[key]);//target属性存在，合并
        }
    } else if (Object.prototype.toString.call(target) === '[object Array]' && Object.prototype.toString.call(source) === '[object Array]') {
        for (let i = 0; i < source.length; i++) {
            if (target[i] === source[i]) continue;//相同，跳过
            if (!target[i]) target.push(source[i]);//target元素不存在，直接添加
            else target[i] = merge(target[i], source[i]);//target元素存在，合并
        }
    } else {//其他情况，直接赋值
        target = source;
    }
    // 返回target
    return target;

}


// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiTinyMCE.js